export default "__VITE_ASSET__BX1F_UfV__"